import { render } from "./ListaDeAgendamentosView.vue?vue&type=template&id=522d3a8e"
import script from "./ListaDeAgendamentosView.vue?vue&type=script&lang=js"
export * from "./ListaDeAgendamentosView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__